export default __webpack_public_path__ + "static/media/lds-logo_ro.ff54652091fb9a9d.svg";